module.exports = __webpack_public_path__ + "static/media/L-belasting-1.13a5a7a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/L-belasting-1.svg
// module id = 120
// module chunks = 0